import {createContext,useContext} from "react";
import type {UseSiteSettings} from "./useSiteSettings";
export const SiteSettingsContext=createContext<UseSiteSettings|null>(null);
export function useSiteSettingsContext(): UseSiteSettings {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) {
    throw new Error("useSiteSettingsContext, SiteSettingsProvider içinde kullanılmalıdır.");
  }
  return ctx;
}